module.exports = __webpack_public_path__ + "static/AppStoreIconPropal-c860d012835f7b849d96d6e39c8ce4a8.jpg";